import {useRef, useState} from 'react'

export const useDebouncedAction = (initialValue: any, timer?: number) => {
    const [state, setState] = useState<any>(initialValue)
    const timerRef: any = useRef(undefined)
  
    const performDebouncedAction = (value: any, action?:any) => {
        setState(value)
        if(action){
            if(timerRef.current){
                clearTimeout(timerRef.current)
            }
            timerRef.current = setTimeout(() => {
                action();
            }, timer || 300)
        }
    }
  
    return [state, performDebouncedAction]
}